import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/5 bg-zinc-950"
    >
      <div className="absolute inset-x-0 -top-px h-px bg-gradient-to-r from-transparent via-purple-500/40 to-transparent" />
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-4">
              <span className="relative inline-flex h-16 w-16 items-center justify-center rounded-xl overflow-hidden ring-1 ring-amber-400/20 shadow-lg shadow-blue-950/40">
                <img
                  src="https://customer-assets.emergentagent.com/job_ooh-impact/artifacts/bi1y53rb_HORIZN%20AD%20MEDIA%20LOGO.png"
                  alt="Horizn Ad Media"
                  className="h-full w-full object-cover object-center scale-[1.45]"
                />
              </span>
              <div>
                <div className="font-display text-xl md:text-2xl font-bold tracking-tight text-white">
                  Horizn Ad Media
                </div>
                <div className="font-mono-accent text-[11px] md:text-xs text-amber-400/80">
                  Private Limited
                </div>
              </div>
            </div>
            <p className="mt-6 text-zinc-400 leading-relaxed max-w-md">
              India's most ambitious Out-of-Home media network. Billboards,
              digital hoardings, transit, cinema, film, and radio, engineered
              to take your brand into the real world.
            </p>
            <div className="mt-6 flex flex-col gap-2 text-sm text-zinc-400">
              <a
                href="mailto:horiznadmediapvtltd@gmail.com"
                className="flex items-center gap-2 hover:text-white transition-colors"
                data-testid="footer-email"
              >
                <Mail className="h-4 w-4 text-blue-400" />
                horiznadmediapvtltd@gmail.com
              </a>
              <a
                href="tel:+919412222077"
                className="flex items-center gap-2 hover:text-white transition-colors"
                data-testid="footer-phone-1"
              >
                <Phone className="h-4 w-4 text-purple-400" />
                +91 94122 22077
              </a>
              <a
                href="tel:+919667722027"
                className="flex items-center gap-2 hover:text-white transition-colors"
                data-testid="footer-phone-2"
              >
                <Phone className="h-4 w-4 text-purple-400" />
                +91 96677 22027
              </a>
              <div className="flex items-start gap-2">
                <MapPin className="h-4 w-4 text-amber-400 mt-0.5 shrink-0" />
                <span>F-2, Savitri Market, Sector 18, Noida, Uttar Pradesh 201301</span>
              </div>
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-mono-accent text-[10px] text-zinc-500 mb-4">
              Company
            </h4>
            <ul className="space-y-3 text-sm">
              {[
                ["About", "/about"],
                ["Services", "/services"],
                ["Insights", "/blog"],
                ["Contact", "/contact"],
              ].map(([label, href]) => (
                <li key={href}>
                  <Link
                    to={href}
                    className="text-zinc-400 hover:text-white transition-colors"
                    data-testid={`footer-link-${label.toLowerCase().replace(/ /g, "-")}`}
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-mono-accent text-[10px] text-zinc-500 mb-4">
              Plan Your Campaign
            </h4>
            <p className="text-sm text-zinc-400 mb-5 leading-relaxed">
              Tell us about your brand. We'll come back with a media plan,
              locations, and pricing within 24 hours.
            </p>
            <Link
              to="/contact"
              data-testid="footer-cta-button"
              className="inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-blue-600 to-purple-600 px-5 py-3 text-sm font-semibold text-white hover:from-blue-500 hover:to-purple-500 transition-all glow-purple"
            >
              Get a Quote <ArrowUpRight className="h-4 w-4" />
            </Link>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-zinc-500">
          <div>
            © {new Date().getFullYear()} Horizn Ad Media Private Limited. All
            rights reserved.
          </div>
          <div className="font-mono-accent">Where Brand Meets The Real World.</div>
        </div>
      </div>
    </footer>
  );
}
